import { combineReducers } from 'redux';

import { byIdReducer } from './byId';
import { idsReducer } from './ids';

export default combineReducers({
    byId: byIdReducer,
    ids: idsReducer,
});
